<script lang="ts">
    import ListItem from './ListItem.svelte';
    import Box from '../_wrappers/Box.svelte';
    import { DEFAULT_LAYOUT } from '$lib/components/constants';
    import { getBoxAttributes } from '$lib/components/_DisplayComponents/_utils/getBoxAttributes';

    // Types
    import type { TransitionEffect } from '$lib/types/Theme';
    import type { ListItemProps } from '$lib/types/Components/List/ListItemProps';
    import type { Align, Box as BoxType, VisualSize } from '$lib/types/Components/SharedTypes';

    export let box: BoxType;
    export let listItems: ListItemProps[] = [];
    export let align: Align = 'left';
    export let textSize: 'small' | 'medium' = 'small';
    export let visualSize: VisualSize = 'small';
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let layout = DEFAULT_LAYOUT;

    const { isInColumn, isInSingleColumn } = layout;

    const hasSingleItem = listItems.length === 1;

    const isSingleColumn = hasSingleItem || (isInColumn && !isInSingleColumn);
</script>

<Box {...getBoxAttributes({ box, isInColumn })} {transitionDelay} {transitionEffect}>
    <div class="grid grid-cols-1 gap-6 text-left {!isSingleColumn && 'md:grid-cols-2'}">
        {#each listItems as listItem}
            <ListItem {...listItem} {align} {textSize} {visualSize} />
        {/each}
    </div>
</Box>
